import types from '../types/start'
import {RENT, TRANSACTIONS} from '../../../endpoints'
import {apiPrivate} from '../../../api'
import {endpoint as endpointText} from '../../../common/text'
import {push} from 'react-router-redux'
import simpleSnackbarActions from '../../../common/actions/simpleSnackbar'
import {Map} from 'immutable'
import {User} from '../../../state/actions'
import loginActions from '../../login/actions/login'

export default class start {

  static createSelfRent() {
    return (dispatch, getState) => {

      const dataStart = getState().ui.remove.start
      const dataCalendar = getState().ui.remove.calendar

      const itemIDs = dataStart.get('items').toArray().map(i => i.get('ID'))
      const startDate = dataCalendar.get('dateStart').format('X')
      const endDate = dataCalendar.get('dateEnd').format('X')
      const startTimeSlot = dataCalendar.get('timeslotStart')
      const endTimeSlot = dataCalendar.get('timeslotEnd')
      const address = dataCalendar.get('address')

      dispatch({type: types.CREATE_SELF_RENT})

      return apiPrivate.get(RENT + '/rent/created?new=&type=3')
        .then(response => {
          let rent = response.data.description

          return Promise.all(itemIDs.map(itemID => {
              const formData = new FormData()
              formData.append('object_id', itemID)
              return apiPrivate.put(RENT + '/rent/' + rent.ID + '/object', formData)
            }),
          )
            .then(() => {

              const formData = new FormData()
              formData.append('start_date', startDate)
              formData.append('time_slot_start_date', startTimeSlot)
              formData.append('end_date', endDate)
              formData.append('time_slot_end_date', endTimeSlot)
              formData.append('address', address)

              return apiPrivate.put(RENT + '/rent/' + rent.ID, formData)
                .then(response => {
                  rent = response.data.description

                  return Promise.all([
                    apiPrivate.get(TRANSACTIONS + '/transactions/price/' + rent.Delivery.ID),
                    apiPrivate.get(TRANSACTIONS + '/transactions/price/' + rent.Pickup.ID),
                  ])
                    .then(results => {
                      const deliveryCost = results[0].data.description
                      const pickupCost = results[1].data.description

                      dispatch({
                        type: types.CREATE_SELF_RENT_SUCCESS,
                        payload: {
                          rent,
                          deliveryCost,
                          pickupCost,
                        },
                      })
                      return true
                    })
                    .catch(error => {throw error})
                })
                .catch(error => {throw error})
            })
            .catch(error => {throw error})
        })
        .catch(error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch({type: types.CREATE_SELF_RENT_FAIL, payload: {error: message}})
              return false
            }
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch({type: types.CREATE_SELF_RENT_FAIL, payload: {error: message}})
          dispatch(simpleSnackbarActions.showMessage(message))
          return false
        })
    }
  }

  static saveDatesAndTimeSlotsForRent(rentID, startDate, startTimeSlot, endDate, endTimeSlot) {
    return dispatch => {

      dispatch({type: types.SAVE_DATES_AND_TIME_SLOTS_FOR_RENT})

      const formData = new FormData()
      formData.append('start_date', startDate)
      formData.append('time_slot_start_date', startTimeSlot)
      formData.append('end_date', endDate)
      formData.append('time_slot_end_date', endTimeSlot)

      return apiPrivate.put(RENT + '/rent/' + rentID, formData)
        .then(response => {
          const rent = response.data.description

          return Promise.all([
            apiPrivate.get(TRANSACTIONS + '/transactions/price/' + rent.Delivery.ID),
            apiPrivate.get(TRANSACTIONS + '/transactions/price/' + rent.Pickup.ID),
          ])
            .then(results => {
              const deliveryPrice = results[0].data.description
              const pickupPrice = results[1].data.description

              dispatch({
                type: types.SAVE_DATES_AND_TIME_SLOTS_FOR_RENT_SUCCESS,
                payload: {
                  rent,
                  deliveryPrice,
                  pickupPrice,
                },
              })
              return true
            })
            .catch(error => {throw error})
        })
        .catch(error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch({type: types.SAVE_DATES_AND_TIME_SLOTS_FOR_RENT_FAIL, payload: {error: message}})
              return false
            }
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch({type: types.SAVE_DATES_AND_TIME_SLOTS_FOR_RENT_FAIL, payload: {error: message}})
          return false
        })
    }
  }

  static modifyAndConfirmRent() {
    return (dispatch, getState) => {

      const dataStart = getState().ui.remove.start
      const dataSummary = getState().ui.remove.summary

      const rentID = dataStart.getIn(['rent', 'ID'])
      const addressID = dataSummary.get('address')
      const cardID = dataSummary.get('card')
      const comments = dataSummary.get('comment')

      dispatch({type: types.MODIFY_AND_CONFIRM_RENT})

      const formData = new FormData()
      formData.append('address', addressID)
      if (cardID !== -1) formData.append('card_id', cardID)
      formData.append('comments', comments)

      return apiPrivate.put(RENT + '/rent/' + rentID, formData)
        .then(() => {

          return apiPrivate.put(RENT + '/rent/' + rentID + '/confirm')
            .then(() => {

              dispatch({
                type: types.MODIFY_AND_CONFIRM_RENT_SUCCESS,
              })
              return true
            })
            .catch(error => {throw error})
        })
        .catch(error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch({type: types.MODIFY_AND_CONFIRM_RENT_FAIL, payload: {error: message}})
              return false
            }
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch({type: types.MODIFY_AND_CONFIRM_RENT_FAIL, payload: {error: message}})
          dispatch(simpleSnackbarActions.showMessage(message))
          return false
        })
    }
  }

  static createReturnTransaction() {
    return (dispatch, getState) => {

      const dataStart = getState().ui.remove.start
      const dataCalendar = getState().ui.remove.calendar

      const itemIDs = dataStart.get('items').toArray().map(i => i.get('ID'))
      const date = dataCalendar.get('dateStart').format('X')
      const timeSlot = dataCalendar.get('timeslotStart')
      const address = dataCalendar.get('address')

      dispatch({type: types.CREATE_RETURN_TRANSACTION})

      return apiPrivate.get(TRANSACTIONS + '/transactions/created?type=4')
        .then(response => {
          let transaction = response.data.description

          return Promise.all(itemIDs.map(itemID => {
            const formData = new FormData()
            formData.append('object_id', itemID)
            return apiPrivate.put(TRANSACTIONS + '/transactions/' + transaction.ID + '/objects', formData)
          }))
            .then(() => {

              const formData = new FormData()
              formData.append('date', date)
              formData.append('time_slot_id', timeSlot)
              formData.append('address', address)

              return apiPrivate.put(TRANSACTIONS + '/transactions/' + transaction.ID, formData)
            })
            .then(() => apiPrivate.get(TRANSACTIONS + '/transactions/price/' + transaction.ID))
            .then(response => {
              const deliveryCost = response.data.description

              dispatch({
                type: types.CREATE_RETURN_TRANSACTION_SUCCESS,
                payload: {
                  transaction,
                  deliveryCost,
                },
              })
              return true
            })
            .catch(error => {throw error})
        })
        .catch(error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch({type: types.CREATE_RETURN_TRANSACTION_FAIL, payload: {error: message}})
              return false
            }
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch({type: types.CREATE_RETURN_TRANSACTION_FAIL, payload: {error: message}})
          dispatch(simpleSnackbarActions.showMessage(message))
          return false
        })
    }
  }

  static saveDatesAndTimeSlotsForReturn(transaction, date, timeSlot) {
    return dispatch => {

      dispatch({type: types.SAVE_DATES_AND_TIME_SLOTS_FOR_RETURN})

      const formData = new FormData()
      formData.append('date', date)
      formData.append('time_slot_id', timeSlot)

      return apiPrivate.put(TRANSACTIONS + '/transactions/' + transaction.ID, formData)
        .then(() => apiPrivate.get(TRANSACTIONS + '/transactions/price/' + transaction.ID))
        .then(response => {
          const deliveryPrice = response.data.description

          dispatch({
            type: types.SAVE_DATES_AND_TIME_SLOTS_FOR_RETURN_SUCCESS,
            payload: {
              transaction,
              deliveryPrice,
            },
          })
          return true
        }, error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch({type: types.SAVE_DATES_AND_TIME_SLOTS_FOR_RETURN_FAIL, payload: {error: message}})
              return false
            }
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch({type: types.SAVE_DATES_AND_TIME_SLOTS_FOR_RETURN_FAIL, payload: {error: message}})
          return false
        })

    }
  }

  static modifyAndConfirmReturn() {
    return (dispatch, getState) => {

      const dataStart = getState().ui.remove.start
      const dataSummary = getState().ui.remove.summary

      const transactionID = dataStart.getIn(['transaction', 'ID'])
      const addressID = dataSummary.get('address')
      const cardID = dataSummary.get('card')
      const comments = dataSummary.get('comment')

      dispatch({type: types.MODIFY_AND_CONFIRM_RETURN})

      const formData = new FormData()
      formData.append('address', addressID)
      if (cardID !== -1) formData.append('card_id', cardID)
      formData.append('comments', comments)

      return apiPrivate.put(TRANSACTIONS + '/transactions/' + transactionID, formData)
        .then(() => apiPrivate.put(TRANSACTIONS + '/transactions/' + transactionID + '/confirm'))
        .then(() => {
          dispatch({
            type: types.MODIFY_AND_CONFIRM_RETURN_SUCCESS,
          })
          return true
        })
        .catch(error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch({type: types.MODIFY_AND_CONFIRM_RETURN_FAIL, payload: {error: message}})
              return false
            }
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch({type: types.MODIFY_AND_CONFIRM_RETURN_FAIL, payload: {error: message}})
          dispatch(simpleSnackbarActions.showMessage(message))
          return false
        })
    }
  }

  static setWillReturnItems(bool) {
    return {
      type: types.SET_WILL_RETURN_ITEMS,
      payload: {
        willReturnItems: bool,
      },
    }
  }

  static addItem(item) {
    return {
      type: types.ADD_ITEM,
      payload: {
        item: Map.isMap(item) ? item : Map(item),
      },
    }
  }

  static removeItem(itemID) {
    return {
      type: types.REMOVE_ITEM,
      payload: {
        itemID,
      },
    }
  }

}



// WEBPACK FOOTER //
// ./src/sections/remove/actions/start.js